<ng-container *ngIf="(selectedAttachments|async)?.length>0">
  <div *ngFor="let attachment of selectedAttachments|async" (click)="attachmentClicked(attachment)" class="attachment-container">
    <h3>
      <span>
        <p *ngIf="attachment.title">{{attachment.title}}</p>
        <p>{{attachment.createdAt | date: 'MM/dd/yyyy h:mm:ss a'}}</p>
      </span>
      <span>
        <button mat-icon-button [mat-dialog-close]="null">
          <mat-icon>close</mat-icon>
        </button>
      </span>
    </h3>
    <section>
      <div *ngIf="isImage(attachment)" class="image-wrapper">
        <img mat-card-image [src]="attachment.downloadUrl | authImage | async | safeUrl">
      </div>
      <div *ngIf="!isImage(attachment) ">
        <img mat-card-image src="../../../../assets/imgs/icons8-document.svg">
      </div>
    </section>

    <section>
      <mat-form-field color="primary" appearance="standard">
        <mat-label>Notes</mat-label>
        <input matInput [(ngModel)]="attachment.description">
      </mat-form-field>
    </section>

    <div mat-dialog-actions>
      <button mat-button color="warn" (click)="deleteAttachment(attachment)">Delete</button>
      <button *ngIf="!isImage(attachment)" (click)="downloadAttachment(attachment)" mat-flat-button color="primary" >Download</button>
      <button mat-flat-button color="primary" (click)="updateAttachment(attachment)">Update</button>
    </div>
  </div>

</ng-container>

<ng-container *ngIf="!((selectedAttachments|async)?.length>0)">
  <div class="attachment-container">
    <h3>
      <span>New Attachment</span>
    </h3>

    <section>
      <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload>
      <img mat-card-image *ngIf="file" [src]="imageSrc" class="image-wrapper">
      <ng-container *ngIf="!file">
        <button mat-button class="new-attachment-button" color="primary" (click)="fileUpload.click()">
          <mat-icon class="new-attachment-icon">library_add</mat-icon>
        </button>
      </ng-container>
    </section>

    <section>
      <mat-form-field color="primary" appearance="standard">
        <mat-label>Notes</mat-label>
        <input matInput [(ngModel)]="description">
      </mat-form-field>
    </section>

    <div mat-dialog-actions>
      <button mat-button [mat-dialog-close]="null">Close</button>
      <button mat-flat-button color="primary" (click)="save()" [disabled]="!file || wip">Save</button>
    </div>
  </div>

</ng-container>
